import colors from '../../../../theme/colors';

export const activeSlideBackgroundColor = 'rgba(127,186,251,1)';
export const inActiveSlideBackgroundColor = 'rgba(211,213,214,1)';

export const activeSlideBorderColor = 'transparent';
export const inActiveSlideBorderColor = 'rgba(151,151,151,1)';

export const activeKnobBackgroundColor = colors.primaryBlue;
export const inActiveKnobBackgroundColor = colors.white;

export const activeKnobPosition = 'calc(100% - 18px)';
export const inActiveKnobPosition = 'calc(0% - 6px)';
